{
    "Detailstitle": "Détails du segment d'appel",
    "Recordingtitle": "Enregistrement de segments d'appels",
    "Details": "Détails",
    "Recording": "Enregistrement",
    "Value": "Valeur",
    "Collapseall": "Réduire tout",
    "FieldStatistic": "Champ \/ Statistique",
    "Calldatetimevalues": "Valeurs de la date et de l'heure d'appel",
    "Deviceinformation": "Informations sur le dispositif",
    "Calltypestatus": "Type d'appel et statut",
    "Callmovement": "Informations sur le scénario de déplacement des appels",
    "Calldurationvalues": "Valeurs de la durée des appels",
    "Telephoneinformation": "Informations sur le numéro de téléphone",
    "Acdinformation": "Informations sur l'agent ACD",
    "Associatedtelephonyenvironment": "Environnement téléphonique associé",
    "Diagnosticvalues": "Valeurs diagnostiques",
    "Previous": "Précédent",
    "Next": "Suivant",
    "Playrecording": "Lecture de l'enregistrement",
    "Errorplayrecording": "Échec de la récupération de l'enregistrement",
    "Norecording": "Pas d'enregistrement(s)",
    "Retrievingrecordings": "Récupération des enregistrements...",
    "Backtodetails": "Retour aux détails",
    "Segmentid": "Copier l'ID de la chaîne de segments",
    "Copied": "Copié !",
    "Help": "Aide",
    "Close": "Fermer",
    "RecordingTimeoutError": "Le nombre maximum de tentatives pour obtenir les enregistrements de cet appel a été dépassé.",
    "EditableHint": "Cliquez sur la description pour modifier ce champ.",
    "EditPlaceholder": "Cliquez ici pour ajouter une description",
    "ReloadDataP1": "Une entrée a été récemment mise à jour, ",
    "ReloadDataP2": "cliquez ici ",
    "ReloadDataP3": "pour recharger les données.",
    "DescMaxLengthValidation": "La longueur maximale des caractères est de 100.",
    "ConfirmChange": "Confirmer",
    "CancelChange": "Annuler",
    "NAME": "CallDetails",
    "AccountCodeHint": "Cliquez sur le code du compte pour modifier ce champ.",
    "AccountCodePlaceholder": "Cliquez ici pour ajouter un code de compte",
    "DescriptionHint": "Cliquez sur la description pour modifier ce champ.",
    "DescriptionPlaceholder": "Cliquez ici pour ajouter une description",
    "NoAccountCodes": "Pas de codes de compte disponibles",
    "First": "D'abord",
    "Last": "Dernier",
    "CallJourneyTitle": "Appeler le voyage",
    "CallRecordingTitle": "Enregistrement des appels",
    "CallSegmentTitle": "Segment {} de {}",
    "TabTextTimeline": "Chronologie",
    "TabTextSegments": "Segments",
    "TabTextRecording": "Enregistrement",
    "StatisticDeviceCalled": "Nom\/Numéro appelé",
    "StatisticDeviceCalling": "Nom\/Numéro d'appel",
    "StatisticTotalCallTime": "Durée totale de l'appel",
    "StatisticStatus": "Statut",
    "Answered": "Répondu",
    "NotAnswered": "Pas de réponse",
    "StatisticTotalCallTimeInProgress": "Appel en cours"
}